<google-map *ngIf="mapaOptions" width="100%" [height]="mapaHeight" [center]="centerGoogleMaps" [options]="mapaOptions">
  <map-polygon *ngFor="let data of poligonos; trackBy: trackByLoteAndColor; let idx = index" [options]="data.poligono"
    [paths]="data.paths" (polygonClick)="selecionarLote(data, idx)"></map-polygon>
  <map-marker *ngIf="markerGoogle" [position]="markerGoogle"></map-marker>
</google-map>
